import React, { useEffect, useState } from 'react'
import { breakpoints, media, ResponsiveContainer } from 'app/assets/styles'
import styled from 'styled-components'
import { Close } from 'app/assets/icons'
import { colors } from 'shared/assets/styles'
import { FormattedMessage } from 'react-intl'
import { catalogType } from 'shared/utils'
import { DisplayableProductTile } from 'app/ecommerce/common/components/catalog/product-tile'
import type { ItemInfos } from 'shared/store/ecommerce/order'
import { H4 } from 'app/common/typography'
import type { SelectionScreenInfos } from 'shared/types'
import {
    isKingdomPointsCoupon,
    purchasable
} from 'shared/utils/ecommerce/utils'
import { addProductToCart } from 'shared/store/ecommerce/order'
import { useDispatch } from 'react-redux'
import { untransformPoints } from 'shared/store/kingdom/points'

const { text } = colors

type Props = {
    selectionScreenInfos: ?SelectionScreenInfos,
    handleClose: () => void,
    setCurrentItemInfos: (productInfos: ItemInfos) => void
}

const SelectionScreen = (props: Props) => {
    const dispatch = useDispatch()
    const [width, setWidth] = useState(window.innerWidth)

    useEffect(() => {
        return window.addEventListener('resize', updateWindowDimensions)
    }, [])

    const updateWindowDimensions = () => setWidth(window.innerWidth)

    const { selectionScreenInfos, handleClose, setCurrentItemInfos } = props
    const isSmallScreen = width < breakpoints.small
    const isMobileScreen = width < breakpoints.medium
    const isMediumScreen = width < breakpoints.large
    const contentSize = isMediumScreen ? width : 1280
    const TILE_SIZE = isSmallScreen
        ? (contentSize - 80) / 2
        : isMobileScreen
        ? (contentSize - 20 - 80) / 3
        : (contentSize - 140) / 5

    if (!selectionScreenInfos) {
        return null
    }

    const {
        promotion,
        isImpersonalOperation,
        isKingdomPoints
    } = selectionScreenInfos

    return (
        <StyledResponsiveContainer>
            <CloseButtonContainer
                onClick={() => {
                    if (
                        promotion &&
                        promotion.couponCode &&
                        isKingdomPointsCoupon(promotion.couponCode)
                    ) {
                        dispatch(untransformPoints(promotion.couponCode))
                    }
                    handleClose()
                }}>
                <Close color={text} size={24} />
            </CloseButtonContainer>
            <FormattedMessage
                id={
                    selectionScreenInfos.type === catalogType.MENU
                        ? 'clickandcollect.discounts.selection.menu'
                        : 'clickandcollect.discounts.selection.product'
                }>
                {(message: string) => <StyledH4>{message}</StyledH4>}
            </FormattedMessage>
            <TilesRow>
                {selectionScreenInfos.listItems.map((item, index) => {
                    const {
                        id,
                        image,
                        categoryId,
                        name,
                        type,
                        available
                    } = item
                    return (
                        <DisplayableProductTile
                            key={index}
                            id={id}
                            type={type}
                            name={name}
                            imageUrl={image}
                            IconTopRight={null}
                            currentSelectedOnStore={setCurrentItemInfos}
                            categoryId={categoryId}
                            promotion={selectionScreenInfos.promotion}
                            available={available}
                            promotionToApply={
                                selectionScreenInfos.promotionToApply
                            }
                            coupon={selectionScreenInfos.coupon}
                            onClick={() => {
                                const purchasableProduct = purchasable(
                                    item,
                                    undefined,
                                    promotion
                                )
                                if (purchasableProduct && isKingdomPoints) {
                                    dispatch(
                                        addProductToCart(purchasableProduct)
                                    )
                                }
                                handleClose()
                            }}
                            isImpersonalOperation={isImpersonalOperation}
                            isKingdomPoints={isKingdomPoints}
                            style={{
                                width: TILE_SIZE,
                                height: TILE_SIZE
                            }}
                        />
                    )
                })}
            </TilesRow>
        </StyledResponsiveContainer>
    )
}

const StyledResponsiveContainer = styled(ResponsiveContainer)`
    ${media.large`
        width: auto;
    `}
`

const CloseButtonContainer = styled.div`
    margin: 20px;
`

const StyledH4 = styled(H4)`
    text-align: center;
    padding: 30px 0 60px;
`

const TilesRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    ${media.medium`
        justify-content: center;
        padding-bottom: 40%;
    `}
`
export { SelectionScreen }
